var _defs, _circle, _rect, _path, _path2, _rect2, _rect3, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHanger3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Man",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke: currentColor;\n        stroke-width: 2px;\n      }\n\n      .cls-1, .cls-2 {\n        fill-rule: evenodd;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "currentColor",
    stroke: "currentColor",
    cx: 75.094,
    cy: 45.5,
    r: 12.219
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    stroke: "currentColor",
    x: 74,
    y: 57,
    width: 2,
    height: 36
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    fill: "currentColor",
    stroke: "currentColor",
    d: "M61.589,83.469L73.834,66.916l0.747,0.615L62.336,84.085Zm0,0L73.834,66.916l0.747,0.615L62.336,84.085Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    fill: "currentColor",
    d: "M-82.71,135H233.71v37.341H-82.71V135Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    stroke: "currentColor",
    x: 10,
    y: 10,
    width: 6,
    height: 133
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    fill: "currentColor",
    stroke: "currentColor",
    x: 16,
    y: 10,
    width: 117,
    height: 6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    fill: "currentColor",
    d: "M73.828,11.621h1.861V45.253H73.828V11.621Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHanger3);
export default __webpack_public_path__ + "static/media/hanger-3.24a266556a235c317084f512e7d5da70.svg";
export { ForwardRef as ReactComponent };